// Lightweight market-hours model (all times UTC).
// Spot FX trades ~24h Sun 21:00 → Fri 21:00 UTC, closed weekends.
// CME futures (gold, WTI) trade Sun 22:00 → Fri 21:00 UTC with a daily
// maintenance break 21:00–22:00 UTC. Good enough for an open/closed indicator.

const FUTURES = new Set(["XAUUSD", "WTI", "GOLD", "XAU", "GC", "CL", "OIL"]);

export function forexOpen(now = new Date()) {
  const day = now.getUTCDay(); // 0=Sun … 6=Sat
  const h = now.getUTCHours();
  if (day === 6) return false; // Saturday
  if (day === 0) return h >= 21; // Sunday: opens 21:00 UTC
  if (day === 5) return h < 21; // Friday: closes 21:00 UTC
  return true; // Mon–Thu
}

export function futuresOpen(now = new Date()) {
  const day = now.getUTCDay();
  const h = now.getUTCHours();
  if (day === 6) return false;
  if (day === 0) return h >= 22; // Sunday reopen ~22:00 UTC
  if (day === 5) return h < 21;
  return h !== 21; // daily CME maintenance break 21:00–22:00 UTC
}

export function instrumentOpen(key, now = new Date()) {
  const k = String(key || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  return FUTURES.has(k) ? futuresOpen(now) : forexOpen(now);
}

export function anyMarketOpen(keys, now = new Date()) {
  return (keys || []).some((k) => instrumentOpen(k, now));
}
